import React from "react";
import BookingDetails from "../components/ManageBooking/BookingDetails";
import GuestDetails from "../components/ManageBooking/GuestDetails";
import InfoSection from "../components/ManageBooking/InfoSection";
import PersonalisedBanner from "../components/ManageBooking/PersonalisedBanner";
import SupplementsTable from "../components/ManageBooking/SupplementsTable";

const ManageBooking = ({ bookingDetails }) => {
  return (
    <div>
      <div className="md:w-3/4 mx-auto p-4 md:p-8">
        <div>
          <BookingDetails bookingDetails={bookingDetails} />
        </div>
        <div className="p-4 md:p-8">
          <h1 className="text-2xl uppercase text-mv-darkblue  font-bold">
            guest details & documents
          </h1>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 w-full py-6">
            {bookingDetails?.guest_details?.map((guest_info) => {
              return (
                <div className="flex" key={bookingDetails?.guest_details?.id}>
                  <GuestDetails
                    booking_id={bookingDetails.booking_id}
                    guest_info={guest_info}
                  />
                </div>
              );
            })}
          </div>
          <SupplementsTable
            supplement_details={bookingDetails.supplement_details}
          />
        </div>
        <div className="p-4 md:p-8">
          <InfoSection />
        </div>
      </div>
      <div className="w-screen">
        <PersonalisedBanner />
      </div>
    </div>
  );
};

export default ManageBooking;
